import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import { 
  renderSelectField6,
} from '../../../form-global-components/components-form-components-for-react-final-form';
import {
  NO_YES,
} from '../../../../actions/action-constants';
class BOPModuleProgramRequirements extends Component {
  render() {    
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    id='bopalchoholaftercareprogram' 
                    name='bopalchoholaftercareprogram'
                    label="BOP Alcohol Aftercare Program"
                    footerMessage=''
                    autoFocus
                    dataArray={NO_YES}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    id='bopdrugaftercareprogram' 
                    name='bopdrugaftercareprogram'
                    label="BOP Drug Aftercare Program"
                    footerMessage=''
                    autoFocus
                    dataArray={NO_YES}
                  />
                </Grid>
              </Grid>


              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    id='bopfinancialresponsibilityprogram' 
                    name='bopfinancialresponsibilityprogram'
                    label="BOP Financial Responsibility Program"
                    footerMessage=''
                    autoFocus
                    dataArray={NO_YES}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    id='bopmentalhealthaftercareprogram' 
                    name='bopmentalhealthaftercareprogram'
                    label="BOP Mental Health Aftercare Program"
                    footerMessage=''
                    autoFocus
                    dataArray={NO_YES}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='boppsf' 
                    name='boppsf'
                    label="BOP Public Safety Factor"
                    footerMessage=''
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
BOPModuleProgramRequirements.propTypes = {
  locked: PropTypes.bool,  
}
export default BOPModuleProgramRequirements;